import ManagerReflect from './ManagerReflect';

export default ManagerReflect;
